import * as React from "react";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkText } from "uitk-react-text";

import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { Amenity } from "typings/microserviceModels/packaging-flex-module";

const HotelAmenities = (props: { hotelAmenities: Amenity[] }) => {
  const { hotelAmenities } = props;

  if (!hotelAmenities?.length) {
    return null;
  }

  const hotelAmenitiesKeyHelper = new ItemKeyHelper("packagesHotelCarImageTopCardHotelAmenities");

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkLayoutGrid columns={2} space="one">
        {hotelAmenities.map((amenity) => (
          <UitkLayoutFlex key={hotelAmenitiesKeyHelper.next()}>
            <UitkIcon name={amenity.code.toLowerCase()} size={UitkIconSize.SMALL} />
            <UitkSpacing margin={{ inlinestart: "two" }}>
              <UitkText size={300}>{amenity.text}</UitkText>
            </UitkSpacing>
          </UitkLayoutFlex>
        ))}
      </UitkLayoutGrid>
    </UitkSpacing>
  );
};

export default HotelAmenities;
